import { Component, Input } from "@angular/core";

const VIEWBOX_WIDTH = 629;
const VIEWBOX_HEIGHT = 515;

@Component({
  selector: "onsip-full-web-preview-frame-image",
  templateUrl: "full-web-preview-frame-image.component.html",
  standalone: false
})
export class FullWebPreviewFrameImageComponent {
  @Input() set width(width: number) {
    this._width = width;
    this.height = (width * VIEWBOX_HEIGHT) / VIEWBOX_WIDTH;
  }

  _width: number = VIEWBOX_WIDTH;
  height: number = VIEWBOX_HEIGHT;
}
